import { useTheme } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import BarChart from 'src/shared/components/Charts/BarChart';
import { type ChartValuesAmount } from 'src/shared/types/chartsData';
import { parseLegendKeys } from '../helpers';
import { type PayrollChartData } from '../helpers/payrolls';
import TransferChart from '../TransferChart';

const mapTransferAmountsData = (data: PayrollChartData[]) =>
  data.reduce<{ labels: string[]; values: ChartValuesAmount }>(
    (acc, values) => {
      return {
        ...acc,
        labels: [...acc.labels, values.label],
        values: {
          ...acc.values,
          payflowPlusProcessingAmount: [
            ...acc.values.payflowPlusProcessingAmount,
            values.payflowPlusProcessingTransactionAmount
          ],
          extraPaymentsAmount: [...acc.values.extraPaymentsAmount, values.extraPaymentsTransactionAmount],
          saveflowAmount: [...acc.values.saveflowAmount, values.saveflowTransactionsAmount]
        }
      };
    },
    {
      labels: [],
      values: {
        payflowPlusProcessingAmount: [],
        extraPaymentsAmount: [],
        saveflowAmount: []
      }
    }
  );

export type TransferAmountsProps = {
  data: PayrollChartData[];
};

const TransferAmounts = ({ data }: TransferAmountsProps) => {
  const { t } = useTranslation(['overview', 'common']);
  const mappedData = mapTransferAmountsData(data);
  const legendKeys = parseLegendKeys(mappedData.values);

  return (
    <TransferChart
      data={mappedData.values}
      labels={mappedData.labels}
      Chart={BarChart}
      title={t('common:capitalize', { value: t('total requested') })}
      legendProps={legendKeys}
      stacked
    />
  );
};

export default TransferAmounts;
